import { Group, type GroupProps, Text } from '@mantine/core';
import type { ReactNode } from 'react';

type InfoRowProps = {
  label: ReactNode;
  children: ReactNode;
} & GroupProps;

export const InfoRow = ({ label, children, ...mantineGroupProps }: InfoRowProps) => {
  const isValueBareString = typeof children === 'string' || typeof children === 'number';

  return (
    <Group align="start" justify="space-between" {...mantineGroupProps}>
      {label}
      {isValueBareString ? (
        <Text c="gray.10" fw={500}>
          {children}
        </Text>
      ) : (
        children
      )}
    </Group>
  );
};

InfoRow.Value = ({ children }: Omit<InfoRowProps, 'label'>) => {
  return (
    <Text c="gray.10" fw={500}>
      {children}
    </Text>
  );
};
